module.exports = __webpack_public_path__ + "static/easyeducation-casebg@2x-min-45604a81da4d74243a5ba2a40e9f2536.jpg";